import Color from 'colorjs.io'

export const getBackdropColor = (foregroundColor: string) => {
  const color = new Color(foregroundColor)
  const whiteBackground = new Color('#ffffff')
  const blackBackground = new Color('#000000')

  const whiteContrast = color.contrast(whiteBackground, 'Lstar')
  const blackContrast = color.contrast(blackBackground, 'Lstar')

  return whiteContrast > blackContrast ? 'light' : 'dark'
}
